import axios from "axios";
import { getUrlApi } from "../utils/util";

class ProductService {
    async getHighlights() {
        var url = `${await getUrlApi()}/public`;
        return axios.get(`${url}/products/highlights`);
    }

    async getByStatusAndType(status, type) {
        var url = `${await getUrlApi()}/public`;
        return axios.get(`${url}/products?status=${status}&type=${type}`);
    }

    async getByStatusAndTypeAndLikeName(status, type, query, supplier) {
        var url = `${await getUrlApi()}/public`;
        return axios.get(
            `${url}/products/query?status=${status}&type=${type}&query=${query}&supplier=${supplier}`
        );
    }

    async getByStatusAndTypeAndCategory(status, type, category) {
        var url = `${await getUrlApi()}/public`;
        return axios.get(`${url}/products?status=${status}&type=${type}&category=${category}`);
    }

    async getById(id) {
        var url = `${await getUrlApi()}/public`;
        return axios.get(`${url}/product/${id}`);
    }

    async getByIdWP(id) {
        var url = `${await getUrlApi()}/public`;
        return axios.get(`${url}/product/wp/${id}`);
    }
}

export default new ProductService();
